// Copyright 2016 Sorama B.V.

import { IValueConverter } from "aurelia-binding-ext";
import { NotSupportedError } from "errors/NotSupportedError";
import moment from "moment";

export class StringToDurationValueConverter implements IValueConverter<moment.Duration, string> {
    public toView(value: string): moment.Duration {
        // Make chaining of this converter to a NullToX ValueConverter possible
        if (value === null) {
            return null;
        }

        return moment.duration(value);
    }

    public fromView(value: moment.Duration): string {
        throw new NotSupportedError("StringToDurationValueConverter does not support fromView.");
    }
}
